// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spoiler_wrapper_2Dtzc","title":"Spoiler_title_3aIFt","active":"Spoiler_active_iVxkC","content":"Spoiler_content_9KDFJ"};